import { i as e, n as t } from "./chunk-lit-CSVRLyfQ.js";
import { n, t as r } from "./chunk-BaseElement-BjvyYb5W.js";
import { t as i } from "./chunk-custom-element-C48brGQG.js";
import { n as a, r as o, t as s } from "./chunk-decorate-C_kVLNWp.js";
import { t as c } from "./chunk-query-assigned-elements-DwB2gFM4.js";
import { t as l } from "./chunk-WithShopifyCart-BI7_cyu2.js";
import { n as u, t as d } from "./chunk-ref-DXw7-tkF.js";
import "./chunk-quantity-input-BRuxpSyo.js";
import { t as f } from "./chunk-HTMLUpdateUtility-BPx8z2lY.js";
//#region src/components/product-form.ts
var p = class extends l(r) {
	constructor(...e) {
		super(...e), this.error = null, this.$errorMessage = d();
	}
	async _handleFormSubmit(e) {
		e.preventDefault(), await this.submitForm();
	}
	async submitForm() {
		try {
			this.error = null;
			let e = this.productForm;
			e && (await this.addItemToWithForm(new FormData(e)), this.openCartDrawer());
		} catch (e) {
			this.error = e.errors || e.message || "An error occurred", await this.updateComplete, this.$errorMessage.value?.scrollIntoView({
				behavior: "smooth",
				block: "center"
			});
		}
	}
	get errorHTML() {
		return this.error ? e`<p
        class="body bg-brand-error/5 text-brand-error mt-4 rounded-xs p-4 text-sm"
        ${u(this.$errorMessage)}
      >
        ${this.error}
      </p>` : t;
	}
	get productForm() {
		return Array.from(this.assignedElements).find((e) => e.tagName === "FORM");
	}
	render() {
		return e`
      <slot @submit=${this._handleFormSubmit}></slot>
      ${this.errorHTML}
    `;
	}
};
s([a()], p.prototype, "error", void 0), s([c()], p.prototype, "assignedElements", void 0), p = s([i("product-form")], p);
//#endregion
//#region src/components/variant-picker.ts
var m = "variant-picker:change", h = class extends n {
	connectedCallback() {
		super.connectedCallback(), this._handleOptionChange = this._handleOptionChange.bind(this), this.addEventListener("change", this._handleOptionChange);
	}
	disconnectedCallback() {
		super.disconnectedCallback(), this.removeEventListener("change", this._handleOptionChange);
	}
	_handleOptionChange(e) {
		e.stopPropagation();
		let t = e.target, n = t.tagName === "SELECT" ? t.selectedOptions[0] : t, r = t.closest("fieldset")?.querySelector("[data-selected-value]");
		r && (r.textContent = (t.tagName, t.value)), t && this.$emit("variant-picker:change", {
			event: e,
			target: n,
			variantId: n.dataset.variantId,
			productUrl: n.dataset.productUrl,
			selectedOptionValues: this.selectedOptionValues
		});
	}
	get selectedOptionValues() {
		return Array.from(this.querySelectorAll("select, fieldset input:checked")).map(({ dataset: e }) => e.optionValueId).filter(Boolean);
	}
};
h = s([i("variant-picker")], h);
//#endregion
//#region src/entry/core/core-main-product.ts
var g = class extends n {
	constructor(...e) {
		super(...e), this.$htmlUpdateUtility = new f(this);
	}
	connectedCallback() {
		super.connectedCallback(), this.handleVariantPickerChange = this.handleVariantPickerChange.bind(this), this.addEventListener(m, this.handleVariantPickerChange), this.$htmlUpdateUtility.addPostProcessCallback(() => {
			window?.Shopify?.PaymentButton?.init();
		});
	}
	disconnectedCallback() {
		super.disconnectedCallback(), this.removeEventListener(m, this.handleVariantPickerChange);
	}
	updateURL(e, t) {
		this.shouldUpdateUrl && window.history.replaceState({}, "", `${e}${t ? `?variant=${t}` : ""}`);
	}
	handleVariantPickerChange(e) {
		let t = e.detail.productUrl, n = e.detail.variantId;
		n && n.trim() !== "" && (this.updateURL(t ?? "", n), t && t !== "" && t !== this.productUrl && (this.productUrl = t), this.$htmlUpdateUtility.fetchAndReplaceSectionId({
			renderRoot: this,
			sectionId: this.sectionId,
			baseUrl: t || this.productUrl,
			params: {
				variant: n,
				...this.view ? { view: this.view } : {}
			},
			withCache: !0
		}).catch((e) => {
			if (e instanceof Error) throw e;
			console.warn(e);
		}).then(() => {
			this.sideEffectUpdate(n);
		}));
	}
	sideEffectUpdate(e) {
		let t = document.querySelectorAll("[data-variant-update]"), n = Array.from(t).map((e) => e.getAttribute("section-id") || "");
		n.length !== 0 && this.$htmlUpdateUtility.fetchAndReplaceSections({
			renderRoot: document.body,
			sectionIds: n,
			baseUrl: this.productUrl,
			withCache: !0,
			params: { variant: e }
		});
	}
};
s([o({
	type: String,
	attribute: "section-id"
})], g.prototype, "sectionId", void 0), s([o({
	type: String,
	attribute: "product-url"
})], g.prototype, "productUrl", void 0), s([o({
	type: String,
	attribute: "view"
})], g.prototype, "view", void 0), s([o({
	type: String,
	attribute: "update-url",
	converter: (e) => e === "true"
})], g.prototype, "shouldUpdateUrl", void 0), g = s([i("main-product")], g);
//#endregion
export { g as MainProduct };
